module.exports = __webpack_public_path__ + "static/media/add.fb4f128f.svg";